import React, { useCallback, useEffect, useRef } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { makeStyles } from '@material-ui/core';
import useRequest from '@hooks/useRequest';
import {
  DetailedRequestInput,
  ReferenceFileInput
} from '@routes/NewRequest/FormComponents';
import PCBStepProps, { DesignRequestForm } from './types';

const CuircuitDesignStep: React.FC<PCBStepProps> = ({
  setDisabledNextButton,
  nextButtonAction
}) => {
  const { requestContainer } = usePCBRequestStyles();
  const { requestState, onUpdateRfqInfo } = useRequest();
  const formProps = useForm<DesignRequestForm>({
    mode: 'onChange',
    defaultValues: {
      detailedRequest:
        (requestState?.detailedRequest ?? '').length > 0
          ? requestState?.detailedRequest
          : undefined
    }
  });
  const { register, errors, watch } = formProps;
  const { detailedRequest } = watch();
  const currentFormValue = useRef<DesignRequestForm>({
    detailedRequest:
      (requestState?.detailedRequest ?? '').length > 0
        ? requestState?.detailedRequest
        : undefined
  });

  const onSubmit = useCallback(() => {
    const { detailedRequest } = currentFormValue.current;
    onUpdateRfqInfo({
      detailedRequest: detailedRequest
    });
  }, [onUpdateRfqInfo]);

  useEffect(() => {
    currentFormValue.current = {
      detailedRequest
    };
  }, [detailedRequest]);

  useEffect(() => {
    nextButtonAction.current.DESIGN = onSubmit;
  }, [nextButtonAction, onSubmit]);

  useEffect(() => {
    if (!setDisabledNextButton) return;
    setDisabledNextButton((detailedRequest ?? '').length === 0);
  }, [detailedRequest, setDisabledNextButton]);

  useEffect(() => {
    return onSubmit;
    //eslint-disable-next-line
  }, []);

  return (
    <div className={requestContainer}>
      <FormProvider {...formProps}>
        <form>
          <DetailedRequestInput
            ref={register({
              required: '상세 요청사항을 입력해주세요'
            })}
            error={errors.detailedRequest?.message}
          />
          <ReferenceFileInput />
        </form>
      </FormProvider>
    </div>
  );
};

export default CuircuitDesignStep;

const usePCBRequestStyles = makeStyles((theme) => ({
  requestContainer: {
    width: '100%',
    maxWidth: '464px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '72px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0
    }
  }
}));
